/* eslint-disable no-nested-ternary */
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import Fail from '../../../assets/icons/fail'
import { Loading } from '../../../components/Loading/Loading'
import { ContainerSheetsStatusStyle, SheetsStatusStyle } from './styles'
import { CheckedIcon } from '../../../assets/icons/Checked'

type SheetsStatusProps = {
  mensagem: String
}

export function SheetsStatus({ mensagem }: SheetsStatusProps) {
  const navigate = useNavigate()

  const goToPage = (url: string) => {
    navigate(url)
  }

  // eslint-disable-next-line consistent-return
  const handleUpload = async () => {
    if (mensagem === 'sucesso') {
      const timer = setTimeout(() => {
        goToPage('/empresas')
        const timer2 = setTimeout(() => {
          goToPage('/planilhas')
        }, 0)
        return () => clearTimeout(timer2)
      }, 0)
      return () => clearTimeout(timer)
    }

    goToPage('/planilhas')
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (mensagem === 'sucesso') {
      const timer1 = setTimeout(() => {
        const timer3 = setTimeout(() => {
          goToPage('/empresas')
          const timer4 = setTimeout(() => {
            goToPage('/planilhas')
          }, 0)
          return () => clearTimeout(timer4)
        }, 0)
        return () => clearTimeout(timer3)
      }, 2000)
      return () => clearTimeout(timer1)
    }
  }, [mensagem === 'sucesso'])

  return (
    <ContainerSheetsStatusStyle type="button" onClick={() => handleUpload()}>
      <SheetsStatusStyle>
        {mensagem === 'failed' ? (
          <>
            <Fail />
            <h1>
              Algo de errado aconteceu, <br />
              confira sua planilha.
            </h1>
          </>
        ) : mensagem === 'sucesso' ? (
          <>
            <CheckedIcon />
            <h1>Planilha importada com sucesso!</h1>
          </>
        ) : (
          <h1>
            <Loading contrast={false} />
            Carregando...
          </h1>
        )}
      </SheetsStatusStyle>
    </ContainerSheetsStatusStyle>
  )
}
